"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgInEmptyCap = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["bg"];
var MAP = {
  usual: '#ECF4F6',
  transparent: 'transparent'
};

var SvgInEmptyCap = function SvgInEmptyCap(_ref) {
  var bg = _ref.bg,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "100%",
    height: "100%",
    viewBox: "0 0 453 453",
    fill: "none"
  }, rest), /*#__PURE__*/_react.default.createElement("mask", {
    id: "ec-mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "453",
    height: "453"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "226.5",
    cy: "226.5",
    r: "226.5",
    fill: "#ECEFF4"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#ec-mask0)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "226.5",
    cy: "226.5",
    r: "226.5",
    fill: MAP[bg]
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M371.865 245.431C370.513 250.84 369.161 258.953 371.865 262.334C379.979 268.419 407.7 255.573 417.166 193.37C427.601 124.795 365.78 79.1057 326.565 65.5833C287.35 52.0609 243.318 100.024 286.674 121.701C334.003 145.365 365.047 159.843 373.217 197.427C379.979 228.528 373.669 238.216 371.865 245.431Z",
    fill: "url(#ec-paint0_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M277.209 320.48C275.045 323.726 279.913 358.118 282.618 375.922C281.266 392.825 265.039 381.331 265.039 381.331C248.271 365.645 240.473 335.58 238.67 322.509C247.685 322.058 268.013 321.021 277.209 320.48Z",
    fill: "url(#ec-paint1_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M283.294 292.084C394.878 280.555 430.237 256.475 457.057 233.261C466.973 250.39 484.101 287.756 448.943 305.606C404.995 327.918 389.217 322.501 280.589 330.622C63.5552 346.849 8.11324 313.043 20.9593 284.646C40.2284 242.051 100.066 311.015 283.294 292.084Z",
    fill: "url(#ec-paint2_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M402.291 208.921C397.423 245.161 375.922 270.899 365.781 279.237L354.963 280.59C365.377 271.8 388.093 250.967 390.121 211.626C392.323 168.907 352.934 118.997 358.343 116.293C361.048 114.94 408.376 163.621 402.291 208.921Z",
    fill: "url(#ec-paint3_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M225.824 225.148C204.729 228.934 181.425 226.725 174.439 225.148L178.496 260.306C178.496 270.222 183.904 290.461 205.54 292.083C232.585 294.112 258.278 281.942 266.391 280.589C272.882 279.508 307.409 287.801 323.861 292.083C340.313 284.646 372.001 262.334 367.133 232.585C361.048 195.398 338.06 190.665 313.719 188.637C285.999 186.327 252.193 220.415 225.824 225.148Z",
    fill: "url(#ec-paint4_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M344.145 231.233L328.594 229.205L315.072 237.994L308.987 263.011C310.339 269.321 314.666 284.105 321.157 292.76C333.597 291.137 346.624 278.111 351.582 271.8L344.145 231.233Z",
    fill: "url(#ec-paint5_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M336.031 229.881C307.905 247.189 322.058 284.421 332.651 300.873C331.749 305.381 330.081 317.506 327.918 329.946C221.091 298.845 233.261 252.869 255.573 229.881C277.885 206.893 311.015 206.893 336.031 229.881Z",
    fill: "url(#ec-paint6_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M345.497 313.043C343.334 312.503 334.679 302.451 330.623 297.493C328.82 303.127 325.89 318.858 328.594 336.708C331.975 359.02 342.117 357.667 345.497 356.315C348.878 354.963 345.497 340.088 344.145 332.651C342.793 325.214 345.497 315.072 345.497 313.043Z",
    fill: "url(#ec-paint7_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M283.97 389.445L282.618 375.922C271.8 383.36 237.318 376.598 240.022 392.149C241.885 402.86 269.772 394.854 283.97 389.445Z",
    fill: "url(#ec-paint8_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M308.31 212.302C320.21 227.447 313.269 243.403 308.31 249.488C279.913 281.942 222.443 215.006 214.33 208.245C206.216 201.484 181.876 199.455 152.127 184.581C122.377 169.706 113.588 141.309 127.786 110.884C141.985 80.4584 175.791 89.248 204.188 102.77C232.585 116.293 256.249 156.86 269.095 173.087C281.942 189.314 293.436 193.37 308.31 212.302Z",
    fill: "url(#ec-paint9_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M418.518 290.732C431.5 291.273 440.154 298.169 442.859 301.55V309.663C439.478 306.282 429.607 299.386 417.166 298.845C401.615 298.169 369.838 301.55 344.821 286.675C319.805 271.8 237.318 186.609 196.075 159.565C179.562 148.736 168.354 151.451 173.087 144.69C182.553 135.9 225.824 171.059 237.318 180.524C248.812 189.99 338.06 273.153 359.696 283.294C381.332 293.436 402.291 290.056 418.518 290.732Z",
    fill: "url(#ec-paint10_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M221.767 244.755C210.52 229.759 192.469 235.966 185.933 240.022C180.524 263.01 147.394 302.225 118.997 298.845C96.2794 296.14 77.5284 276.983 70.9925 267.743L58.1463 266.391C58.3716 279.463 64.7722 310.339 88.5716 329.27C118.321 352.934 156.184 334.003 185.933 318.452C215.682 302.901 242.051 271.8 221.767 244.755Z",
    fill: "url(#ec-paint11_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M112.236 204.864C94.3861 214.6 97.1357 227.401 100.742 232.585L116.969 245.431L120.349 250.84C120.124 254.672 118.862 267.473 115.616 288.027C160.24 315.072 208.245 259.63 185.933 223.796C163.621 187.961 134.548 192.694 112.236 204.864Z",
    fill: "url(#ec-paint12_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M137.252 232.585C131.376 225.533 110.433 229.881 100.742 232.585C102.094 233.036 104.123 235.695 104.123 242.727C104.123 251.517 84.1463 250.164 88.5718 271.8C94.6569 301.549 135.224 285.999 134.548 275.857C133.872 265.715 124.406 267.743 124.406 261.658C124.406 256.925 144.013 240.698 137.252 232.585Z",
    fill: "url(#ec-paint13_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M168.354 217.034C158.212 207.569 150.099 215.006 148.746 218.386C154.606 223.345 167.002 233.667 169.706 235.29C172.636 232.36 176.467 224.607 168.354 217.034Z",
    fill: "#E0E7F4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M181.2 125.082L63.5552 214.33L65.5836 266.391C95.1075 287.576 161.052 333.462 188.637 347.525C258.413 253.41 212.752 160.015 181.2 125.082Z",
    fill: "url(#ec-paint14_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M72.3448 271.8L58.8224 272.476C57.4702 272.544 53.4134 262.334 51.3851 256.925C49.3567 251.516 52.0612 241.375 61.5269 241.375C69.0994 241.375 71.894 261.658 72.3448 271.8Z",
    fill: "url(#ec-paint15_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M57.4701 194.723V243.403H64.9074V194.723C64.9074 193.821 64.2313 192.018 61.5268 192.018C58.8223 192.018 57.6955 193.821 57.4701 194.723Z",
    fill: "url(#ec-paint16_linear)"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M348.201 164.973C350.365 180.118 345.754 191.894 343.5 195.5C345.979 206.093 362.895 214.614 364 220C377.522 211.887 386.064 164.973 359.696 127.111C333.327 89.248 340.088 64.9077 348.201 59.4987C356.315 54.0898 362.4 60.851 361.724 66.936C361.048 73.0211 349.554 82.4868 358.343 88.5719C367.133 94.6569 379.979 85.8674 381.331 73.0211C382.684 60.1748 379.303 40.5674 352.934 40.5674C326.566 40.5674 318.452 57.4704 317.1 83.839C315.748 110.208 345.497 146.042 348.201 164.973Z",
    fill: "url(#ec-paint17_linear)"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "ec-paint0_linear",
    x1: "298.169",
    y1: "63.555",
    x2: "377.275",
    y2: "274.504",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#CD67DF"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#F4ECFA"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "ec-paint1_linear",
    x1: "260.644",
    y1: "320.48",
    x2: "260.644",
    y2: "381.331",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#4878DA"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#6E92DC"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "ec-paint2_linear",
    x1: "18.9313",
    y1: "283.97",
    x2: "450.972",
    y2: "288.703",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#F4ECFA"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#CD67DF"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "ec-paint3_linear",
    x1: "378.897",
    y1: "116.265",
    x2: "378.897",
    y2: "280.59",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#F4ECFA"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#CD67DF"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "ec-paint4_linear",
    x1: "181.876",
    y1: "263.01",
    x2: "361.048",
    y2: "240.698",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#6F93DC"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#7194DD"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "ec-paint5_linear",
    x1: "309.663",
    y1: "248.812",
    x2: "351.582",
    y2: "266.391",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.0723179",
    stopColor: "#4B79DA"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.572565",
    stopColor: "#7093DC"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "ec-paint6_linear",
    x1: "240.699",
    y1: "256.249",
    x2: "335.355",
    y2: "288.027",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#3669D1"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.35646",
    stopColor: "#7397DF"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "ec-paint7_linear",
    x1: "323.861",
    y1: "330.623",
    x2: "347.525",
    y2: "331.975",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#DFE5F8"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#C3D2EA"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "ec-paint8_linear",
    x1: "261.921",
    y1: "376.598",
    x2: "261.921",
    y2: "397.434",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#DCE4F1"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#BBCCE9"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "ec-paint9_linear",
    x1: "127.787",
    y1: "103.447",
    x2: "210.949",
    y2: "169.706",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#CD67DF"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#F4ECFA"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "ec-paint10_linear",
    x1: "171.735",
    y1: "143.338",
    x2: "462.466",
    y2: "302.226",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#CD67DF"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#F3ECFA"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "ec-paint11_linear",
    x1: "51.3851",
    y1: "267.743",
    x2: "233.937",
    y2: "269.095",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#6C91DC"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#4979DA"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "ec-paint12_linear",
    x1: "93.3045",
    y1: "229.881",
    x2: "192.018",
    y2: "251.516",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#6C91DC"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#3564C7"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "ec-paint13_linear",
    x1: "85.191",
    y1: "261.658",
    x2: "151.451",
    y2: "258.278",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#E9F0F9"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.608215",
    stopColor: "#C2D3ED"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "ec-paint14_linear",
    x1: "60.8507",
    y1: "232.585",
    x2: "237.994",
    y2: "219.739",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "white",
    stopOpacity: "0.47"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.760417",
    stopColor: "white",
    stopOpacity: "0"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "ec-paint15_linear",
    x1: "45.976",
    y1: "256.925",
    x2: "73.0208",
    y2: "265.715",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#E2E7F5"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#C5D1EB"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "ec-paint16_linear",
    x1: "58.1462",
    y1: "217.711",
    x2: "68.288",
    y2: "217.711",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#4B79DA"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#6C91DC"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "ec-paint17_linear",
    x1: "349.319",
    y1: "40.5674",
    x2: "349.319",
    y2: "219.678",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#7899DC"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#4676D9"
  }))));
};

exports.SvgInEmptyCap = SvgInEmptyCap;
var bg = ['usual', 'transparent'];
SvgInEmptyCap.modes = {
  bg: bg
};
SvgInEmptyCap.propTypes = {
  bg: (0, _propTypes.oneOf)(bg)
};
SvgInEmptyCap.defaultProps = {
  bg: 'usual'
};